import React, { useState, useEffect } from "react";
import { Box, Button, Card, TextField, Typography, IconButton, Grid, MenuItem, Select, InputLabel, FormControl, Chip } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
const PaymentScreenOlympiad = ({ payload, proceed, editMode, dataPropCoordinators }) => {
  const [coordinators, setCoordinators] = useState([
    {
      name: "",
      email: "",
      mobile: "",
      role: "",
      subject: ""
    }
  ]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [errors, setErrors] = useState({});

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validateMobile = (mobile) =>
    /^[0-9]{10}$/.test(mobile);

  // const subjectOptions = [
  //   ...new Set(
  //     payload?.olympiadDetails?.classSubjects?.flatMap(cls =>
  //       cls.subjects.map(s => s.subjectName)
  //     ) || []
  //   )
  // ];

  useEffect(() => {
  if (editMode && dataPropCoordinators?.length) {
    const mapped = dataPropCoordinators.map((item) => ({
      name: item.name || "",
      email: item.email || "",
      mobile: item.mobile || "",
      role: item.role || "",
      subject: Number(item.subject_id) || ""   // ✅ important
    }));

    setCoordinators(mapped);
  }
}, [editMode, dataPropCoordinators]);


  const subjectOptions = [
    ...new Map(
      (payload?.olympiadDetails?.classSubjects || [])
        .flatMap(cls =>
          cls.subjects.map(s => [
            s.subjectId,
            { id: s.subjectId, name: s.subjectName }
          ])
        )
    ).values()
  ];

  console.log(payload, proceed, "ssdlmnadskbasdkbasdkb")
  const addCoordinator = () => {
    setCoordinators([
      ...coordinators,
      { name: "", email: "", mobile: "", role: "", subject: "" }
    ]);
  };

  const removeCoordinator = (index) => {
    const updated = coordinators.filter((_, i) => i !== index);
    setCoordinators(updated);
  };

  const handleChange = (index, field, value) => {
    console.log(index, field,"sdsdsdsd", value, "indexindexindex")
    const updated = [...coordinators];
    if(field === "subject") {
      
    }
    updated[index][field] = value;

    let tempErrors = { ...errors };

    if (!tempErrors[index]) tempErrors[index] = {};

    if (field === "email") {
      tempErrors[index].email =
        value && !validateEmail(value) ? "Invalid email format" : "";
    }

    if (field === "mobile") {
      tempErrors[index].mobile =
        value && !validateMobile(value)
          ? "Mobile must be 10 digits"
          : "";
    }

    setErrors(tempErrors);
    setCoordinators(updated);
  };

  const handleProceed = () => {
    let hasError = false;
    let tempErrors = {};

    coordinators.forEach((coord, index) => {
      tempErrors[index] = {};

      if (!coord.subject) {
        tempErrors[index].subject = "Select subject";
        hasError = true;
      }

      if (!validateEmail(coord.email)) {
        tempErrors[index].email = "Invalid email";
        hasError = true;
      }

      if (!validateMobile(coord.mobile)) {
        tempErrors[index].mobile = "Enter valid 10-digit mobile";
        hasError = true;
      }
    });

    setErrors(tempErrors);
    if (hasError) return;

    // ✅ Pass subjectId forward
    const finalPayload = {
      ...payload,
      coordinators
    };

    proceed(finalPayload);
  };
console.log(dataPropCoordinators,"dataPropdataProp")
  return (
    <Box p={2}>

      <Typography variant="h5" mb={2}>
        Coordinator Details
      </Typography>

      {coordinators.map((coord, index) => (
        <Card key={index} sx={{ p: 2, mb: 2 }}>
          {console.log(typeof coord.subject, coord.subject)}
{console.log(typeof subjectOptions[0]?.id, subjectOptions[0]?.id)}

          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6">
              Coordinator {index + 1}
            </Typography>

            <Box>
              {coordinators.length > 1 && (
                <IconButton onClick={() => removeCoordinator(index)}>
                  <Remove />
                </IconButton>
              )}
              <IconButton onClick={addCoordinator}>
                <Add />
              </IconButton>
            </Box>
          </Box>

          <Grid container spacing={2} mt={1}>
            <Grid item xs={12}>
              {/* <FormControl fullWidth>
                <InputLabel>Subject</InputLabel>
                <Select
                  value={coord.subjects || ""}
                  onChange={(e) =>
                    handleChange(index, "subjects", e.target.value)
                  }
                >
                  {subjectOptions.map((sub, i) => (
                    <MenuItem key={i} value={sub}>
                      {sub}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
              <FormControl fullWidth error={!!errors[index]?.subject}>
                <InputLabel>Subject</InputLabel>
                <Select
                  value={coord.subject || ""}
                  label="Subject"
                  onChange={(e) =>
                    handleChange(index, "subject", e.target.value)
                  }
                >
                  <MenuItem value="9999">General Coordinator</MenuItem>
                  {subjectOptions.map((sub) => (
                    <MenuItem key={sub.id} value={sub.id}>
                      {sub.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Name"
                value={coord.name}
                onChange={(e) =>
                  handleChange(index, "name", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Email"
                value={coord.email}
                error={!!errors[index]?.email}
                helperText={errors[index]?.email}
                onChange={(e) =>
                  handleChange(index, "email", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Mobile Number"
                value={coord.mobile}
                error={!!errors[index]?.mobile}
                helperText={errors[index]?.mobile}
                inputProps={{ maxLength: 10 }}
                onChange={(e) =>
                  handleChange(
                    index,
                    "mobile",
                    e.target.value.replace(/\D/g, "") // only numbers
                  )
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Designation"
                value={coord.role}
                onChange={(e) =>
                  handleChange(index, "role", e.target.value)
                }
              />
            </Grid>
          </Grid>
        </Card>
      ))}

      <Box mt={3} display="flex" justifyContent="flex-end">
        <Button variant="contained" onClick={handleProceed}>
          Proceed
        </Button>
      </Box>

    </Box>
  );
};

export default PaymentScreenOlympiad;